import React from "react";
import { useTranslation } from "react-i18next";

/**
 * BlueSources — WIDGET CONVERSATIONNEL (correctif final).
 *
 * Dans le widget de chat, pour TOUS les rôles (public, membre, partenaire, admin,
 * super_admin) : on n'affiche PLUS « Sources utilisées », ni le titre du document,
 * ni le nom du partenaire, ni le nombre de documents, ni la liste déroulante des
 * sources. Blue donne simplement sa réponse.
 *
 * On conserve UNIQUEMENT un badge générique discret (« Information partenaire
 * approuvée » ou « Fait vérifié ») qui ne révèle AUCUN document précis (ni titre,
 * ni partenaire nommé, ni identifiant).
 *
 * NB : le backend continue d'envoyer les sources/provenances complètes — elles
 * restent disponibles pour Blue Studio, l'audit, la revue interne et la traçabilité.
 * Ce composant se contente de NE PAS les rendre dans le widget.
 */
export function BlueSources({ sources }) {
  const { t } = useTranslation();
  if (!sources || sources.length === 0) return null;

  // Badge générique : si au moins une source est une information partenaire,
  // on l'indique de façon générique (jamais le nom du partenaire) ; sinon « Fait vérifié ».
  const isPartner = sources.some((s) => {
    const type = ((s.badge && s.badge.type) || s.type || "").toUpperCase();
    return type.includes("PARTNER") || Boolean(s.partner_slug);
  });
  const label = isPartner
    ? t("blue.badgePartnerApproved", { defaultValue: "Information partenaire approuvée" })
    : t("blue.badgeVerifiedFact", { defaultValue: "Fait vérifié" });

  return (
    <div className="blue-sources" data-testid="blue-sources">
      <span
        className="blue-src-badge blue-src-badge--positive"
        data-testid="blue-source-badge"
        aria-label={label}
        title={label}
      >
        {label}
      </span>
    </div>
  );
}

export default BlueSources;
